import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Register.css"
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import Loaderdots from "../../components/LoaderDots/Loaderdots";

const Register = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    phone: "",
  });

  const [loading, setLoading] = useState(false); // Loader state
  const navigate = useNavigate();

  useEffect(() => {
  const token = localStorage.getItem("userToken");
  if(token){
    navigate("/");
  }
}, [])

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Show loader when API call is in progress

    try {
      const response = await fetch("https://riymay.com/api/v1/user/registration", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      

      const data = await response.json();
      
      if (!response.ok) {
        toast.error(data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
          toastId:"notRespose"
        });
                // toast.error(data.message);
        throw new Error(data.message || "Registration failed");
      }
      toast.success("✅ Registration successful! Redirecting to OTP verification...", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
        toastId:"okRespose"

       
      });

      setTimeout(() => {
        navigate("/otp-verification", { state: { email: formData.email } });
      }, 3000); 
      
    } catch (err) {
      console.error(err)
      // toast.error(`❌ ${err.message}`, {
      //   position: "top-right",
      //   autoClose: 3000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   theme: "colored",
      // });
      
    } finally {
      setLoading(false); // Hide loader after the request completes
    }
  };

 if (loading) return <div><Loaderdots /></div>
 

  return (
    <div className="register-container">
    <div className="register-box">
      <form className="register-form-container" onSubmit={handleFormSubmit}>
        {/* {error && <p className="register-error">{error}</p>}
        {successMessage && <p className="register-success">{successMessage}</p>} */}
        <h2 className="register-heading">Register</h2>

        <div className="register-form-group">
          <input
            type="text"
            name="firstName"
            className="register-input"
            placeholder="First Name"
            value={formData.firstName}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="register-form-group">
          <input
            type="text"
            name="lastName"
            className="register-input"
            placeholder="Last Name"
            value={formData.lastName}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="register-form-group">
          <input
            type="email"
            name="email"
            className="register-input"
            placeholder="Email"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="register-form-group">
          <input
            type="password"
            name="password"
            className="register-input"
            placeholder="Password"
            value={formData.password}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="register-form-group">
          <input
            type="number"
            name="phone"
            className="register-input"
            placeholder="Phone"
            value={formData.phone}
            onChange={handleInputChange}
          />
        </div>

        <div className="register-links">
          <Link to="/login" className="register-signin">Login</Link>
        </div>

        <button type="submit" className="register-button" disabled={loading}>
          {loading ? <span className="loader"></span> : "Register"}
        </button>
      </form>
    </div>
  </div>
  );
};

export default Register;
